import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { TestFileType } from '../../constants/enums';
import { t } from '../../i18n/i18n';
import { fileToObject } from '../../utils/fileToObject';
import { PlusOutlined } from '@ant-design/icons';
import './UploadChallengePDF.scss';

const UploadChallengePDF = ({ addFile, id }) => (
  <div data-testid="upload-challenge-pdf" className="d-flex">
    <label
      data-testid="upload-challenge-pdf-label"
      className="text-purple text-xs font-weight-500 cursor-pointer m-0"
      htmlFor={`pdf-${id}`}
    >
      <OverlayTrigger
        placement="top"
        overlay={
          <Tooltip className="" placement="top">
            {t('CREATE_CHALLENGE_ASYNC_UPLOAD_FILE_TOOLTIP')}
          </Tooltip>
        }
      >
        <div className="d-flex align-items-center gap-1 border-pill py-1 px-3">
          <PlusOutlined style={{ color: '#4987be' }} /> {t('CREATE_CHALLENGE_ASYNC_UPLOAD_FILE')}
        </div>
      </OverlayTrigger>
    </label>
    <input
      data-testid="upload-challenge-pdf-input"
      onChange={(e) => addFile(fileToObject(e.target.files[0]), TestFileType.PDF)}
      type="file"
      accept="application/pdf"
      id={`pdf-${id}`}
      className="d-none"
      value=""
    />
  </div>
);

export default UploadChallengePDF;
